
import React from "react";

interface FormHeaderProps {
  title: string;
  description: string;
}

export const FormHeader = ({ title, description }: FormHeaderProps) => {
  return (
    <div className="text-center">
      <h2 className="text-3xl font-bold text-gameGold">{title}</h2>
      <p className="mt-2 text-gray-300">{description}</p>
    </div>
  );
};
